
/* Koszyk Zabezpieczonej — dodawanie bez przeładowania, podgląd, usuwanie. */
(function () {
  var root = document.getElementById('zbDrawer');
  if (!root) return;

  var body  = root.querySelector('[data-items]');
  var total = root.querySelector('[data-total]');
  var toast = document.getElementById('zbToast');
  var busy  = false;

  function zl(cents) {
    return (cents / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zl';
  }
  function money(cents) { return zl(cents).replace('zl', 'zł'); }

  function open()  { root.dataset.open = '1'; root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { delete root.dataset.open; root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function flash(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.dataset.show = '1';
    setTimeout(function () { delete toast.dataset.show; }, 2200);
  }

  function counters(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-cart-open]').forEach(function (el) { el.hidden = n === 0; });
  }

  function render(cart) {
    counters(cart.item_count);
    if (total) total.textContent = money(cart.total_price);

    if (!cart.items.length) {
      body.innerHTML = '<p class="zb-empty">Koszyk jest pusty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">'
        : '<span class="zb-line__ph"></span>';
      return '<div class="zb-line">' + img + '<div>' +
        '<b>' + it.product_title + '</b>' +
        '<span class="zb-price">' + money(it.line_price) + '</span>' +
        '<div class="zb-line__row">' +
          '<span class="zb-qty">' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Mniej">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Więcej">+</button>' +
          '</span>' +
          '<button type="button" class="zb-rm" data-line="' + (i + 1) + '" data-qty="0">Usuń</button>' +
        '</div></div></div>';
    }).join('');
  }

  function refresh(andOpen) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (andOpen) open(); return cart; });
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { flash('Nie udało się zmienić koszyka'); })
      .finally(function () { busy = false; });
  }

  function add(id, label) {
    if (busy) return;
    busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function () {
        /* Szuflada otwiera sie sama i pokazuje, co doszlo — toast byłby tylko hałasem. */
        return refresh(true);
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]');
    if (a) {
      e.preventDefault();
      var lab = a.dataset.label || '';
      add(a.dataset.add, lab);
      return;
    }
    var o = e.target.closest('[data-cart-open]');
    if (o) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-line]');
    if (q && root.contains(q)) { change(Number(q.dataset.line), Number(q.dataset.qty)); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.dataset.open) close();
  });

  refresh(false);
})();
